export enum STATUS_COLORS {
  // GuaranteeApplication Statuses
  Auto = 'bg-blue-primary',
  WaitProcessing = 'bg-orange-warning',
  Processed = 'bg-green-success',
  Archived = 'bg-neutral-700',
  WillNotDo = 'bg-pink-900',

  // Prescription Statuses
  Guaranteed = 'bg-green-success',
  NotGuaranteed = 'bg-red-error-dark',
  Planned = 'bg-blue-primary',
  NotPlanned = 'bg-orange-warning',
  Completed = 'bg-green-success',
  Confirmed = 'bg-green-success',
  Unknown = 'bg-orange-warning',

  // Actions & Appointments Statuses
  ToDo = 'bg-orange-warning',
  Done = 'bg-green-success',
  Rejected = 'bg-red-error-dark',
  Created = 'bg-orange-warning',
  Cancelled = 'bg-red-error-dark',

  // Protocol Statuses
  Draft = 'bg-blue-primary',
  Active = 'bg-green-success',

  // Recommendation Statuses
  Deactivated = 'bg-red-error-dark',

  // Other
  Undefined = 'bg-gray-3',
  Inactive = 'bg-gray-3',
}
